import styled from 'styled-components';
import { breakpoints } from '../../theme';

export const NavBar = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  z-index: 1000;
  padding: 0.5rem 0;
  padding-top: 10.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  text-align: center;

  @media (max-width: ${breakpoints.tablet}) {
    padding-top: 6rem;
  }
`;

export const NavTabs = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const NavTab = styled.a<{ $active: boolean }>`
  text-decoration: none;
  padding: 0.5rem 1rem;
  font-weight: bold;
  border: 2px solid ${(props) => (props.$active ? props.theme.primary : 'transparent')};
  border-radius: 5px;
  color: ${(props) => (props.$active ? props.theme.primary : props.theme.text)};
  background: ${(props) => (props.$active ? 'rgba(255, 255, 255, 0.6)' : 'transparent')};
  transition: color 0.3s ease, border-color 0.3s ease, background 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.5);
    color: ${(props) => props.theme.primary};
  }
`;

export const GlassContentWrapper = styled.div`
  padding: 6rem 0 4rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  backdrop-filter: blur(12px);
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.1);
  width: 85%;
  margin: 5rem auto;
  margin-top: 4rem;
  
  @media (max-width: 768px) {
    padding: 1rem;
    width: 95%;
    /* Only titles/labels need centering, so leave text alignment unchanged here */
  }
`;

export const SectionWrapper = styled.div`
  padding: 5rem 2rem;
  background: ${(props) => (props.id === 'core-values' ? '#f9f9f9' : 'transparent')};
  border-bottom: 1px solid ${(props) => props.theme.borderColor || '#e0e0e0'};
  
  &:last-child {
    border-bottom: none;
  }
  
  @media (max-width: 768px) {
    padding: 3rem 0rem;
    margin-top: 2rem;
  }
`;

export const GlassContainer = styled.div`
  max-width: 80vw;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  backdrop-filter: blur(12px);
  padding: 2rem;
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    max-width: 100%;
    padding: .5rem;
  }
`;

export const WhiteCard = styled.div`
  background: #ffffff;
  border-radius: 10px;
  padding: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 0.5rem;
  }
`;

export const SectionContentWrapper = styled.section`
  h2, h3, h4 {
    font-size: 2rem;
    color: ${(props) => props.theme.primary};
    margin-bottom: 1rem;
    font-weight: bold;
    @media (max-width: 768px) {
      text-align: center;
    }
  }

  p {
    font-size: 1.1rem;
    color: ${(props) => props.theme.text};
    line-height: 1.6;
    margin-bottom: 2rem;
    /* Keep paragraphs left aligned even on mobile */
    text-align: left;
  }

  em {
    font-style: italic;
    color: ${(props) => props.theme.secondary};
  }
`;
